import * as types from "../types";
import { ActionsCreators } from "../../actions";
import { requestAuth, axiosAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";
import axios from "axios";
import { GetDefaultContentLangs, GetDefaultTranslations } from "../../helpers/Language";
import { reportError } from "../../helpers/FetchApi";
import { format } from "date-fns";
import { TagFacesOutlined } from "@mui/icons-material";

export const actionCreators = {

    parseDate: (dateString) => () => {
        if (dateString === "0001-01-01T00:00:00") {
            return null;
        }
        // Toutes les dates sont en UTC mais l'API ne renvoi pas forcément le bon format, on ajoute le "Z"
        // qui indique que les dates sont au format UTC
        if (!dateString.endsWith("Z")) {
            dateString = dateString + "Z";
        }
        const date = new Date(dateString);
        //01.09.2024 · 10:20
        return format(date, "dd.MM.yyyy · HH:mm");
    },

    parseDay: (dateString) => () => {
        if (dateString === "0001-01-01T00:00:00") {
            return null;
        }
        // Toutes les dates sont en UTC mais l'API ne renvoi pas forcément le bon format, on ajoute le "Z"
        // qui indique que les dates sont au format UTC
        if (!dateString.endsWith("Z")) {
            dateString = dateString + "Z";
        }
        const date = new Date(dateString);
        //01.09.2024 · 10:20
        return format(date, "yyyy.MM.dd");
    },

    parseHour: (dateString) => () => {
        if (dateString === "0001-01-01T00:00:00") {
            return null;
        }
        // Toutes les dates sont en UTC mais l'API ne renvoi pas forcément le bon format, on ajoute le "Z"
        // qui indique que les dates sont au format UTC
        if (!dateString.endsWith("Z")) {
            dateString = dateString + "Z";
        }
        const date = new Date(dateString);
        //10:20
        return format(date, "HH:mm");
    },

    GetContentTypesList: () => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/ContentTypes", { method: "GET" }).then((data) => {
            //Associate ID to Page
            for (let i = 0; i < data.length; i++) {
                switch (data[i].id) {
                    /*case 10 : data[i].page = "WebURL";
                        break;*/
                    case 20 : data[i].page = "Image";
                        break;
                    case 30 : data[i].page = "Video";
                        break;
                    case 40 : data[i].page = "PDF";
                        break;
                    /*case 400 : data[i].page = "Facebook";
                        break;*/
                    /*case 60 : data[i].page = "Drugstores";
                        break;*/
                    case 70 : data[i].page = "Agenda";
                        break;
                    case 80 : data[i].page = "Directory";
                        break;
                    case 90 : data[i].page = "Map";
                        break;
                    case 110 : data[i].page = "Ads";
                        break;
                    case 120 : data[i].page = "MediaGallery";
                        break;
                    case 130 : data[i].page = "WPReider";
                        break;
                    case 140 : data[i].page = "PDFLibrary";
                        break;
                    case 150 : data[i].page = "FlipCard";
                        break;
                    case 160 : data[i].page = "MemoryGame";
                        break;
                    case 170 : data[i].page = "JobBoard";
                        break;
                    case 180 : data[i].page = "WPNews";
                        break;
                    case 210 : data[i].page = "Twitter";
                        break;
                    /*case 310 : data[i].page = "CustomNews";
                        break;*/
                    case 510: data[i].page = "JaliosAgenda";
                        break;
                    default : null;
                }
            }

            data.sort((a, b) => { return a.index - b.index; });

            return dispatch({ type: types.GET_DICTIONNARY_CONTENTTYPES, assets: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetContentsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) => async (dispatch, store) => {
        secondary ? dispatch({ type: types.GET_CONTENTS_SECONDARY_COMPLETED, payload: null }) : dispatch({ type: types.GET_CONTENTS_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/OrganizationContents/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            secondary ? dispatch({ type: types.GET_CONTENTS_SECONDARY_COMPLETED, payload: data }) : dispatch({ type: types.GET_CONTENTS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveContentPagination: (paginationType) => (dispatch, store) => {
        const data = store().contents.contents;
        dispatch({ type: types.GET_CONTENTS_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },

    GetSecondaryContentsList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => (dispatch) => {
        dispatch(ActionsCreators.GetContentsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, true));
    },

    GetContent: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/" + id, {
            method: "GET"
        }).then((data) => {
            return onSuccess({
                content: data,
                userAccessLevel: data.userAccessLevel
            });
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetContentSize: (onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/OrganisationContentSize/" + store().currentuser.currentorganization.id, {
            method: "GET"
        }).then((data) => {
            dispatch({ type: types.GET_CONTENTS_STORAGESPACE, payload: data });
            if (onSuccess) {
                return onSuccess(data);
            }
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetUnusedContentsList: (onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/InutilizedContentsList/" + store().currentuser.currentorganization.id, {
            method: "GET"
        }).then((data) => {
            return onSuccess(
                data
            );
        }).catch( (data) => {
            console.log("error", data);
        });
    },


    DeleteContent: (contentId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/" + contentId, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.contentDeleted);
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DeleteContents: (object, onSuccess) => async (dispatch, store) => {

        const data = new FormData();
        data.append("sizeListedElementAsString", JSON.stringify(object));

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/DeleteContents/" + store().currentuser.currentorganization.id, {
            body: data,
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.contentDeleted);
            return onSuccess();
        }).catch( (data) => {
            console.log("error", data);
            return onSuccess();
        });
    },

    EditContent: (changedContent, onSuccess, onError) => (dispatch, store) => {
        dispatch({ type: types.OPEN_UPLOAD_MANAGER });

        /* Use axios for upload progress */
        axiosAuth(
            `${appSettings.SKALINKAPIURL}/api/Content/${store().currentuser.currentorganization.id}`,
            {
                method: "PUT",
                data: changedContent,
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                    dispatch({ type: types.UPDATE_UPLOAD_PROGRESS, progress: progress });
                }
            })
            .then(function (response) {
                dispatch({ type: types.CLOSE_UPLOAD_MANAGER });
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                if (onError) {onError();}
                console.log(error);
                //reportError(appSettings.SKALINKAPIURL + "/api/Content/" + store().currentuser.currentorganization.id, changedContent, error.response, error.response.status, error.response.data);
                dispatch({ type: types.CLOSE_UPLOAD_MANAGER });
            });
    },

    CreateContent: (formData, onSuccess, onError) => (dispatch, store) => {
        /* Use axios for upload progress */
        axiosAuth(
            `${appSettings.SKALINKAPIURL}/api/Content/${store().currentuser.currentorganization.id}`,
            {
                method: "POST",
                data: formData,
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                    dispatch({ type: types.UPDATE_UPLOAD_PROGRESS, progress: progress });
                }
            }
        )
            .then(function (response) {
                onSuccess(response.data.result);
                dispatch({ type: types.UPDATE_UPLOAD_PROGRESS, progress: 0 });
            })
            .catch(function (error) {
                if (onError) {onError();}
                reportError(appSettings.SKALINKAPIURL + "/api/Content/" + store().currentuser.currentorganization.id, formData, error, error.status, error.data);
                dispatch({ type: types.CLOSE_UPLOAD_MANAGER });
            });
    },

    SaveTemporaryDocument: (file, onSuccess, onError) => (dispatch, store) => {
        const formData = new FormData();
        formData.append("document", file);

        axiosAuth(appSettings.SKALINKAPIURL + "/api/Content/SaveTemporaryDocument/" + store().currentuser.currentorganization.id,           
            {
                method: "POST",
                data: formData,               
                onUploadProgress: progressEvent => {
                    const progress = parseInt(Math.round( progressEvent.loaded * 100 / progressEvent.total ));
                    dispatch({ type: types.UPDATE_UPLOAD_PROGRESS, progress: progress });
                }
            }
        )
            .then(function (response) {
                onSuccess(response.data.result);
            })
            .catch(function (error) {
                if (onError) {onError();}
            });
    },

    GetFontsList: () => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Style/FontFamilies", {
            method: "GET"
        }).then((data) => {
            const family = [];
            data.forEach(el => {
                family.push({ name: el, id: family.length });
            });
            return dispatch({ type: types.GET_FONTS_COMPLETED, assets: family });
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DuplicateContent: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Content/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.contentDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            if (data.body.errorCode === "duplicate") {}
            console.log(data);
        });
    },

    CheckTwitterUserName: (name, onSuccess, onError) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ExternalAPI/CheckTwitterUserName/" + store().currentuser.currentorganization.id + "?"
        + "userName=" + name, {
            method: "GET"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
            return onError(data);
        });
    },

    CreateSingleContent: (formData, onSuccess, onError) => (dispatch, store) => {
        dispatch({ type: types.OPEN_UPLOAD_MANAGER });
        // Upload file
        dispatch(ActionsCreators.CreateContent(formData, (result) => {
            // Close upload manager
            dispatch({ type: types.CLOSE_UPLOAD_MANAGER });
            onSuccess(result);
        },
        () => {
            if (onError) {onError();}
        }
        ));
    },

    CreateContents: (files, contentGroup, tagsToAdd, tagsToCreate, onSuccess) => (dispatch, store) => {
        dispatch({ type: types.OPEN_UPLOAD_MANAGER });

        console.log("CreateContents");

        const langs = store().currentuser.currentorganization.languages;
        const defaultImage = {
            ShowQRCode: false,
            Translations: JSON.stringify(GetDefaultTranslations(langs))
        };
        const defaultPDF = {
            ShowQRCode: false,
            Translations: JSON.stringify(GetDefaultTranslations(langs)),
            documentType: "FlyerBook"
        };
        const defaultVideo = {
            ShowQRCode: false,
            Translations: JSON.stringify(GetDefaultTranslations(langs)),
            duration: 0
        };
        const defaultContent = {
            id: 0,
            name: "",
            contentTypeId: 20,
            contentLangs: GetDefaultContentLangs(langs),
            data: null
        };

        //Upload first file of array and delete it from the array, repeat until there's no more file to upload
        if (files.length === 0) {
            dispatch({ type: types.CLOSE_UPLOAD_MANAGER });
            return onSuccess();
        }
        else {
            const file = files[0];
            files.splice(0, 1);

            // Put file in progress list
            dispatch({
                type: types.PUT_FILE_IN_PROGRESS,
                file: [{ name: file.name, size: file.size }]
            });

            // Put other files in queue
            const filesQueue = [];
            for (let i = 0; i < files.length; i++) {
                filesQueue.push({
                    name: files[i].name,
                    size: files[i].size
                });
            }
            dispatch({
                type: types.PUT_FILES_IN_QUEUE,
                files: filesQueue
            });

            const formData = new FormData();
            const content = defaultContent;
            content.name = file.name;

            formData.append("files", file);

            if (file.type.indexOf("image") > -1) {
                content.data = JSON.stringify(defaultImage);
                formData.append("contentObjAsString", JSON.stringify(content));
                uploadFile(files, file, formData, contentGroup, tagsToAdd, tagsToCreate, onSuccess, dispatch);
            }
            else if (file.type.indexOf("video") > -1) {
                dispatch({ type: types.UPDATE_UPLOAD_PROGRESS, progress: null });

                content.contentTypeId = 30;

                generateVideoThumbnail(file, (blob, duration) => {
                    formData.append("thumbnailFiles", blob);

                    const data = defaultVideo;
                    data.duration = Math.ceil(duration);
                    content.data = JSON.stringify(data);
                    formData.append("contentObjAsString", JSON.stringify(content));

                    uploadFile(files, file, formData, contentGroup, tagsToAdd, tagsToCreate, onSuccess, dispatch);
                });
            }
            else if (file.type.indexOf("pdf") > -1) {
                content.contentTypeId = 40;
                content.data = JSON.stringify(defaultPDF);
                formData.append("contentObjAsString", JSON.stringify(content));
                generatePDFImages(file, (blobs) => {
                    formData.append("thumbnailFiles", blobs[0]);
                    for (let i = 0; i < blobs.length; i++) {
                        formData.append("files", blobs[i]);
                    }
                    uploadFile(files, file, formData, contentGroup, tagsToAdd, tagsToCreate, onSuccess, dispatch);
                });
            }
        }
    }
};

function uploadFile(files, file, formData, contentGroup, tagsToAdd, tagsToCreate, onSuccess, dispatch) {
    // Upload file
    dispatch(ActionsCreators.CreateContent(formData, (result) => {
        const id = result;

        const newTagsList = [];

        if (tagsToCreate.length > 0) {
            const values = [];
            tagsToCreate.forEach(tag => {
                values.push(tag.value);
                newTagsList.push(tag);
            });
            dispatch(ActionsCreators.CreateMultipleTag(values, id, "content", () => {

                setTimeout(() => {
                    if (tagsToAdd.length > 0) {
                        tagsToAdd.forEach(tag => {
                            newTagsList.push(tag);
                        });
                        dispatch(ActionsCreators.AddMultipleTag(tagsToAdd, id, "content", () => {
                            dispatch({
                                type: types.PUT_FILE_IN_DONE,
                                file: { name: file.name, size: file.size }
                            });
                            // Upload next file
                            dispatch(ActionsCreators.CreateContents(files, contentGroup, newTagsList, [], onSuccess));
                        }));
                    }
                    else {
                        dispatch({
                            type: types.PUT_FILE_IN_DONE,
                            file: { name: file.name, size: file.size }
                        });
                        // Upload next file
                        dispatch(ActionsCreators.CreateContents(files, contentGroup, newTagsList, [], onSuccess));
                    }
                }, 1000);
            }));
        }
        else if (tagsToAdd.length > 0) {
            tagsToAdd.forEach(tag => {
                newTagsList.push(tag);
            });
            dispatch(ActionsCreators.AddMultipleTag(tagsToAdd, id, "content", () => {
                dispatch({
                    type: types.PUT_FILE_IN_DONE,
                    file: { name: file.name, size: file.size }
                });
                // Upload next file
                dispatch(ActionsCreators.CreateContents(files, contentGroup, newTagsList, [], onSuccess));
            }));
        }
        else {
            dispatch({
                type: types.PUT_FILE_IN_DONE,
                file: { name: file.name, size: file.size }
            });
            // Upload next file
            dispatch(ActionsCreators.CreateContents(files, contentGroup, newTagsList, [], onSuccess));
        }
    }));
}

function b64toBlob(b64string) {

    const block = b64string.split(";");
    // Get the content type of the image
    const contentType = block[0].split(":")[1];
    // get the real base64 content of the file
    const realData = block[1].split(",")[1];

    const byteCharacters = atob(realData);
    const byteArrays = [];
    const sliceSize = 512;

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

function generateVideoThumbnail(file, onSuccess) {
    const thumbnailWidth = 1280;
    const thumbnailHeight = 720;

    const video = document.createElement("video");

    video.addEventListener("loadeddata", function() {
        video.currentTime = 1;
    }, false);

    video.addEventListener("seeked", function() {
        // Génération de la miniature
        const c = document.createElement("canvas");
        const ctx = c.getContext("2d");
        c.width = thumbnailWidth;
        c.height = thumbnailHeight;
        ctx.drawImage(video, 0, 0, thumbnailWidth, thumbnailHeight);
        const img = c.toDataURL("image/png");
        const blob = b64toBlob(img);

        onSuccess(blob, video.duration);
    }, false);

    video.preload = "auto";
    video.src = URL.createObjectURL(file);
}

function generatePDFImages(file, onSuccess) {

    const reader = new FileReader();

    reader.addEventListener("load", () => {
        const result = reader.result;
        const pdfData = atob(result.split(",")[1]);

        pdfjsLib.getDocument({ data: pdfData }).then((pdf) => {
            console.log("the pdf has", pdf.numPages, "page(s).");
            blobs = [];
            renderPages(pdf, 1, (blobs) => {
                onSuccess(blobs);
            });
        });
    }, false);

    reader.readAsDataURL(file);
}

let blobs = [];
function renderPages(pdf, pageNumber, onSuccess) {
    pdf.getPage(pageNumber).then((page) => {
        const scale = 2;
        const viewport = page.getViewport(scale);

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
            canvasContext: context,
            viewport: viewport
        };

        const task = page.render(renderContext);

        task.promise.then(() => {
            const imgB64 = canvas.toDataURL("image/jpeg");
            blobs.push(b64toBlob(imgB64));

            if (pdf.numPages > pageNumber) {
                renderPages(pdf, ++pageNumber, onSuccess);
            }
            else {
                console.log("done rendering");
                onSuccess(blobs);
            }
        });
    });
}
